export default {
  FETCH_NET_SALES_SUMMARY_REQUEST: 'FETCH_NET_SALES_SUMMARY_REQUEST',
  FETCH_NET_SALES_SUMMARY_SUCCESS: 'FETCH_NET_SALES_SUMMARY_SUCCESS',
  FETCH_NET_SALES_SUMMARY_FAILURE: 'FETCH_NET_SALES_SUMMARY_FAILURE',

  FETCH_NET_SALES_DETAILS_REQUEST: 'FETCH_NET_SALES_DETAILS_REQUEST',
  FETCH_NET_SALES_DETAILS_SUCCESS: 'FETCH_NET_SALES_DETAILS_SUCCESS',
  FETCH_NET_SALES_DETAILS_FAILURE: 'FETCH_NET_SALES_DETAILS_FAILURE',

  DOWNLOAD_NET_SALES_REPORT_REQUEST: 'DOWNLOAD_NET_SALES_REPORT_REQUEST',
  DOWNLOAD_NET_SALES_REPORT_SUCCESS: 'DOWNLOAD_NET_SALES_REPORT_SUCCESS',
  DOWNLOAD_NET_SALES_REPORT_FAILURE: 'DOWNLOAD_NET_SALES_REPORT_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/net-sales/action-types.js